import showToaster from '../../../helpers/toastrMessgaes/showToaster';
import {
  getCurrencyRatesQuery,
  getBaseCurrencySubQuery,
  getCurrencyQuery,
  updateCurrencyMutation,
  setBaseCurrencyMutation,
  allowPaymentCurrencyMutation,
  removeCurrencyMutation,
  updatePayoutCurrencyMutation
} from '../../../lib/graphql';
import { closeCurrencyModal } from '../../../actions/siteadmin/modalActions';
import { getCurrenciesData } from '../../currency/getCurrencies';
import {
  CHANGE_CURRENCY_STATUS_START,
  CHANGE_CURRENCY_STATUS_SUCCESS,
  CHANGE_CURRENCY_STATUS_ERROR,
  SET_BASE_CURRENCY_START,
  SET_BASE_CURRENCY_SUCCESS,
  SET_BASE_CURRENCY_ERROR,
  CURRENCY_RATES_FETCH_SUCCESS,
  ADD_CURRENCY_START,
  ADD_CURRENCY_SUCCESS,
  ADD_CURRENCY_ERROR,
  SET_PAYOUT_CURRENCY_START,
  SET_PAYOUT_CURRENCY_SUCCESS,
  SET_PAYOUT_CURRENCY_ERROR
} from '../../../constants';

export const updateCurrencyStatus = (id, isEnable, symbol) => {

  return async (dispatch, getState, { client }) => {

    try {

      dispatch({
        type: CHANGE_CURRENCY_STATUS_START,
      });

      let baseCurrencyId;

      const { data } = await client.query({ query: getBaseCurrencySubQuery, fetchPolicy: 'network-only' });
      if (data?.getBaseCurrency) {
        baseCurrencyId = data?.getBaseCurrency?.id;
      }

      if (baseCurrencyId === id) {
        await showToaster({ messageId: 'failedCurrency', toasterType: 'error' });
      } else {

        const { data } = await client.mutate({
          mutation: updateCurrencyMutation,
          variables: { id, isEnable, symbol },
          refetchQueries: [{ query: getCurrencyQuery, variables: { currentPage: 1, searchList: '' } }]
        });

        if (data.updateCurrency.status === 200) {
          dispatch({
            type: CHANGE_CURRENCY_STATUS_SUCCESS,
          });
          await showToaster({ messageId: 'successCurrency', toasterType: 'success' });
        } else {
          dispatch({
            type: CHANGE_CURRENCY_STATUS_ERROR
          });
          await showToaster({ messageId: 'errorMessage', requestContent: data?.updateCurrency?.errorMessage, toasterType: 'error' });
          return false;
        }
      }
      dispatch(getCurrenciesData())
    } catch (error) {

      dispatch({
        type: CHANGE_CURRENCY_STATUS_ERROR,
        payload: {
          error
        }
      });
      await showToaster({ messageId: 'catchMessage', requestContent: error, toasterType: 'error' });
      return false;
    }
    return true;
  };
}

export const setBaseCurrency = (id) => {

  return async (dispatch, getState, { client }) => {

    try {
      dispatch({
        type: SET_BASE_CURRENCY_START,
      });

      const { data } = await client.mutate({
        mutation: setBaseCurrencyMutation,
        variables: { id },
        refetchQueries: [{ query: getCurrencyQuery, variables: { currentPage: 1, searchList: '' } }]
      });

      if (data?.setBaseCurrency?.status == 200) {
        dispatch({
          type: SET_BASE_CURRENCY_SUCCESS,
        });

        const currency = await client.query({ query: getCurrencyRatesQuery, fetchPolicy: 'network-only' })

        if (currency?.data?.getCurrencyRates) {

          let currencyRates, base;
          base = currency?.data?.getCurrencyRates?.base;

          if (currency?.data?.getCurrencyRates?.rates) {
            currencyRates = JSON.parse(currency?.data?.getCurrencyRates?.rates);
          }

          await showToaster({ messageId: 'baseCurrency', toasterType: 'success' });

          dispatch({
            type: CURRENCY_RATES_FETCH_SUCCESS,
            payload: {
              base,
              to: "",
              rates: currencyRates
            }
          });

          dispatch(getCurrenciesData());
        }
      }

    } catch (error) {
      dispatch({
        type: SET_BASE_CURRENCY_ERROR,
        payload: {
          error
        }
      });
      showToaster({ messageId: 'catchMessage', requestContent: error, toasterType: 'error' });
      return false;
    }
    return true;
  };
}

export const allowPaymentCurrency = (id, isPayment) => {

  return async (dispatch, getState, { client }) => {
    try {

      dispatch({
        type: SET_BASE_CURRENCY_START,
      });

      const { data } = await client.mutate({
        mutation: allowPaymentCurrencyMutation,
        variables: {
          id,
          isPayment: isPayment ? 1 : 0
        },
        refetchQueries: [{ query: getCurrencyQuery }]
      });

      if (data?.allowPaymentCurrency?.status === 200) {
        dispatch({
          type: SET_BASE_CURRENCY_SUCCESS,
        });
        await showToaster({ messageId: 'allowedCurrency', toasterType: 'success' });
      }else {
        dispatch({
          type: SET_BASE_CURRENCY_ERROR,
        });
       let msg = await showToaster({ messageId: 'errorMessage', requestContent: data?.allowPaymentCurrency?.errorMessage, toasterType: 'error', })
      }

    } catch (error) {
      dispatch({
        type: SET_BASE_CURRENCY_ERROR,
        payload: {
          error
        }
      });
      await showToaster({ messageId: 'catchMessage', requestContent: error, toasterType: 'error' });
      return false;
    }
    return true;
  };
}

export const addCurrency = (values) => {

  return async (dispatch, getState, { client }) => {

    try {
      dispatch({
        type: ADD_CURRENCY_START,
      });

      const { data } = await client.mutate({
        mutation: updateCurrencyMutation,
        variables: {
          isEnable: values.isEnable == '1' ? true : false,
          symbol: values.symbol
        },
        refetchQueries: [{ query: getCurrencyQuery, variables: { currentPage: 1, searchList: '' } }]
      });

      if (data?.updateCurrency?.status === 200) {
        dispatch({
          type: CHANGE_CURRENCY_STATUS_SUCCESS,
        });
        await showToaster({ messageId: 'addCurrency', toasterType: 'success' });
      } else {
        dispatch({
          type: CHANGE_CURRENCY_STATUS_ERROR
        });
        await showToaster({ messageId: 'errorMessage', requestContent: data?.updateCurrency?.errorMessage, toasterType: 'error' });

        return false;
      }
      dispatch(closeCurrencyModal());
      dispatch(getCurrenciesData());
    } catch (error) {
      dispatch({
        type: ADD_CURRENCY_ERROR,
        payload: {
          error
        }
      });
      await showToaster({ messageId: 'catchMessage', requestContent: error, toasterType: 'error' });
      dispatch(closeCurrencyModal());
      return false;
    }
    return true;
  };
}


export const removeCurrency = (id, symbol) => {

  return async (dispatch, getState, { client }) => {

    try {

      dispatch({
        type: ADD_CURRENCY_START,
      });

      const { data } = await client.mutate({
        mutation: removeCurrencyMutation,
        variables: {
          id,
          symbol
        },
        refetchQueries: [{ query: getCurrencyQuery, variables: { currentPage: 1, searchList: '' } }]
      });

      if (data?.removeCurrency?.status === 200) {
        dispatch({
          type: ADD_CURRENCY_SUCCESS,
        });
        await showToaster({ messageId: 'deleteCurrency', toasterType: 'success' });
        return { status: 200 }
      } else {
        dispatch({
          type: ADD_CURRENCY_ERROR
        });
        await showToaster({ messageId: 'errorMessage', requestContent: data?.removeCurrency?.errorMessage, toasterType: 'error' });
        return { status: 400 }
      }
      dispatch(getCurrenciesData());
    } catch (error) {
      dispatch({
        type: ADD_CURRENCY_ERROR,
        payload: {
          error
        }
      });
      await showToaster({ messageId: 'catchMessage', requestContent: error, toasterType: 'error' });
      return { status: 400 }
    }
    return true;
  };
}

export const updatePayoutCurrency = ({ id, isPayoutCurrency, symbol }) => {
  return async (dispatch, getState, { client }) => {
    dispatch({ type: SET_PAYOUT_CURRENCY_START });
    try {

      const { data } = await client.mutate({
        mutation: updatePayoutCurrencyMutation,
        variables: { id, isPayoutCurrency, symbol },
      });

      if (data?.updatePayoutCurrency?.status === 200) {
        dispatch({ type: SET_PAYOUT_CURRENCY_SUCCESS });
        showToaster({ messageId: 'payoutCurrencySuccess', toasterType: 'success' });
      } else {
        showToaster({ messageId: 'commonError', requestContent: data?.updatePayoutCurrency?.errorMessage, toasterType: 'error' });
      }

    } catch (error) {
      dispatch({
        type: SET_PAYOUT_CURRENCY_ERROR,
        payload: { error }
      });
      showToaster({ messageId: 'payoutCurrencyFailed', toasterType: 'error' })
      return false;
    }
    return true;
  }
}